module.exports = __webpack_public_path__ + "img/calendar.e3b483a4.svg";